import { render, staticRenderFns } from "./CloseButtonSection.vue?vue&type=template&id=a5e94d00"
import script from "./CloseButtonSection.vue?vue&type=script&lang=js"
export * from "./CloseButtonSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports